module.exports = __webpack_public_path__ + "fepro/img/loading.d57b1545.png";